<!--
 * @Author: gjc
 * @Date: 2022-03-22 11:52:57
 * @LastEditors: gjc
 * @LastEditTime: 2022-03-24 10:10:17
 * @Description: 产业政策详情（天津市）
-->
<template>
  <div class="industry_detail">
    <div class="cont_top">
      <a-tabs v-model="activeName">
        <a-tab-pane tab="政策详情" key="industryDetailTab"></a-tab-pane>
      </a-tabs>

      <p class="title">
        <span :class="{ 'info_max': detailData.title && detailData.title.length >= 45 }">{{ detailData.title }}</span>
      </p>
      <p class="p1">索引号：{{ detailData.indexNo }}</p>
      <p class="p1">发布机构：{{ detailData.dept }}</p>
      <p class="p1">发文字号：{{ detailData.fwzh }}</p>
      <p class="p1">主题：{{ detailData.category }}</p>
      <p class="p1">成文日期：{{ getDateText(detailData.cwDate) }}</p>
      <p class="p1">发文日期：{{ getDateText(detailData.fbDate) }}</p>
    </div>

    <div class="line"></div>

    <div class="mainContent">
      <div class="mainBox2 mainBox">
        <div class="title">
          <span class="desc1"></span>
          <span class="desc2">政策内容</span>
        </div>
        <div class="policy_content" v-html='detailData.content'></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPolicyESDetail } from '@/api/industryPolicy';
export default {
  name: 'industryDetail',
  data() {
    return {
      activeName: 'industryDetailTab',
      detailId: '',
      detailData: {},
    };
  },
  created() {
    this.detailId = this.$route.query.targetId || ''
    this.getPolicyESDetailPro()
  },
  methods: {
    //日期时间文本显示处理
    getDateText(date){
      return date ? date.split(' ')[0] : '-'
    },
    // 获取政策详情
    async getPolicyESDetailPro(){
      // 第二个参数默认传0表示通过列表页进入，传1表示通过微信分享进入
      const {code, data} = await getPolicyESDetail(this.detailId, 0)
      if(code == 0){
        this.detailData = data
      }
    },
  },
};
</script>

<style lang="less" scoped>
.industry_detail {
  height: 100%;
  background: #fff;
  font-family: PingFangSC-Medium, PingFang SC !important;

  ::v-deep .ant-tabs-tab-active {
    font-weight: 500;
    color: #333;
    font-size: 16px;
    padding: 12px 0;
  }

  ::v-deep .ant-tabs-tab {
    padding-top: 0;
  }

  ::v-deep .ant-tabs-ink-bar {
    width: 64px;
  }

  ::v-deep .ant-btn-primary {
    background: #0072f7 !important;
  }

  .cont_top {
    padding: 20px;

    p {
      font-size: 14px;
      font-weight: 400;
      color: #999;
      margin: 0;
    }

    .p1 {
      margin-bottom: 16px;
    }

    .title {
      font-size: 20px;
      font-weight: 500;
      color: #333;
      line-height: 20px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;

      .info_max {
        max-width: 920px;
        white-space: pre-wrap;
      }

      span {
        .collection {
          font-size: 14px;
          font-weight: 400;
          color: #666;
          margin-left: 4px;
        }
      }
    }
  }

  .line {
    height: 10px;
    background: #eff2f5;
  }

  .mainContent {
    padding: 20px;

    .mainBox {
      .title {
        margin-bottom: 22px;
        display: flex;
        align-items: center;

        .desc1 {
          display: inline-block;
          width: 2px;
          height: 16px;
          background: #0072f7;
        }

        .desc2 {
          margin-left: 7px;
          font-size: 16px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          font-family: PingFangSC-Medium, PingFang SC;
        }
      }

      .policy_content {
        font-size: 14px;
        font-weight: 400;
        color: #666;
        line-height: 22px;
      }
    }

    .mainBox2 {
      margin-bottom: 40px;
    }
  }
}
</style>
